module.exports = __webpack_public_path__ + "img/pending.3d6b4689.svg";